import Vue from "vue";
import Vuex from "vuex";
import router from "./router";

Vue.use(Vuex);

const userSaveName = "__expertUser__";

let user = localStorage.getItem(userSaveName);
if (user) {
  try {
    user = JSON.parse(user);
  } catch (e) {
    localStorage.removeItem(userSaveName);
    user = null;
  }
}

export default new Vuex.Store({
  state: {
    user
  },
  getters: {
    user: state => {
      return state.user || false;
    }
  },
  mutations: {
    login(state, { user }) {
      localStorage.setItem(userSaveName, JSON.stringify(user));
      state.user = user;
      router.push("/");
    },
    refresh(state, { user }) {
      localStorage.setItem(userSaveName, JSON.stringify(user));
      state.user = user;
    },
    logout(state) {
      localStorage.removeItem(userSaveName);
      state.user = null;
      router.push("/");
    }
  },
  actions: {
    login({ commit }, payload) {
      commit("login", payload);
    },
    refresh({ commit }, payload) {
      commit("refresh", payload);
    },
    logout({ commit }) {
      commit("logout");
    }
  }
});
